import React, {useEffect} from 'react';
import Layout from '../../components/layout/Layout';
import {fetchApiAuth} from "../../core/utils/api";
import {useParams, useHistory} from 'react-router-dom';
import {Input, Form, Row, Col, Button, message} from 'antd';

interface UserDetails {
    name: string;
    email: string;
    role: string;
    department: number;
    department_name: string;
    division: string | null;
    division_name: string;
    profilePictureFull: string | null;
    status: number;
    two_factor_auth: string | null;
}

const UsersCopy: React.FC = () => {
    const [ loading, setLoading ] = React.useState<boolean>(false);
    const [ isCopying, setIsIsCopying ] = React.useState<boolean>(false);
    const [ , setCopyFromUserDetails ] = React.useState<UserDetails | null>(null);
    const [ form ] = Form.useForm();

    let history = useHistory();
    const {userId} = useParams<{ userId: string }>();
    const onSaveUserClick = () => {
        form.validateFields()
            .then(values => {
                setIsIsCopying(true);
                fetchApiAuth({
                    url: `user-account/copy-user/${userId}`,
                    method: 'POST',
                    body: values
                })
                    .then((response: any) => {
                        setIsIsCopying(false);
                        const responseData = response.data;

                        if (responseData['success']) {
                            message.success('User copied successfully');
                            const newUserId = response.data['new_user_id'];
                            history.push(`/users/view/${newUserId}`);
                        } else {
                            const errors = responseData['errors'];
                            for (let error in errors) {
                                message.error(errors[error]);
                            }
                        }
                    })
                    .catch((error: any) => {
                        setIsIsCopying(false);
                        message.error('Error duplicating user');
                    });
            })
            .catch(errorInfo => {
                console.error('Validation failed:', errorInfo);
            });
    };

    useEffect(() => {
        if (userId) {
            setLoading(true);
            fetchApiAuth({
                url: `user-account/get-user-details`,
                method: 'POST',
                body: {
                    user_id: userId
                }
            })
                .then(res => {
                    setCopyFromUserDetails(res.data);
                    setLoading(false);
                })
                .catch(err => {
                    console.error('Error fetching user details:', err);
                    setLoading(false);
                });
        }
    }, [ userId, form ]);

    return (
        <Layout
            data-test="pages-users-view"
            className="drivers-view"
            title={<div>Copy User</div>}
            headerTitle={<div>Copy User</div>}
            showFooter={false}
            loading={loading}
        >
            <div className={`content-wrap`}>
                <div className="content">
                    <div className="content-inner">
                        <section className="section">
                            <div style={{width: '100%', height: '32px'}}/>
                            <div className="top-section">

                                <div
                                    className="section__action-bar justify-center"
                                    style={{marginBottom: '16px'}}
                                >
                                    <span className="edit-user-title">
                                        Copy User
                                    </span>
                                </div>
                                <Button
                                    type="primary"
                                    onClick={onSaveUserClick}
                                    loading={isCopying}
                                    style={{
                                        position: 'absolute',
                                        top: -10,
                                        right: 16,
                                    }}
                                >
                                    <span>Copy</span>
                                </Button>
                            </div>

                            <Row>
                                <Col span={6} />
                                <Col span={12}>
                                    <Form
                                        form={form}
                                        layout="vertical"
                                    >
                                        <Form.Item
                                            label="New Name"
                                            name="name"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'New name is required!',
                                                }
                                            ]}
                                        >
                                            <Input
                                                placeholder={'Enter New Name'}
                                                autoComplete="off"
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="New Email"
                                            name="email"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'New email is required!',
                                                },
                                                {
                                                    type: 'email',
                                                    message: 'Please enter a valid email address',
                                                }
                                            ]}
                                        >
                                            <Input
                                                placeholder={'Enter New Email'}
                                                autoComplete="off"
                                            />
                                        </Form.Item>
                                    </Form>
                                </Col>
                                <Col span={6} />
                            </Row>

                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default UsersCopy;
